import z from 'zod';
import { DealerDocumentFileSchema } from './DealerDocumentFile';

export const DealerDocumentsResultSchema = z.object({
    data: z.array(DealerDocumentFileSchema),
    total: z.number(),
});

export type DealerDocumentsResult = z.infer<typeof DealerDocumentsResultSchema>;
